import React from 'react'
import { Helmet } from 'react-helmet'
import TopNavigation from '../Components/navigation/TopNavigation'
import MainFooter from '../Components/footer/MainFooter'

function TermsnConditions() {
    
  return (
    <div className="main-layer">
      <Helmet>
              <title>Lovedripp - Terms and Conditions </title>
      </Helmet>
      <TopNavigation title={"Terms and Conditions"} classBack="full-white"/>
      <div className="content-layer">
            <div className="section-item terms-pop">
                <div className="container">
                    <h6>Terms of Service for Lovedripp</h6>
                    <p>Effective Date: 29/07/2025</p>
                    <p>Welcome to Lovedripp! These Terms of Service (“Terms”) govern your use of our platform, located at [www.lovedripp.com] (the “Platform”), operated by Lovedripp (“we,” “us,” or “our”).</p>
                    <p>
                        By creating an account or using any part of the Platform, you agree to these Terms. If you do not agree, please do not use the Platform.<br/>
                        1. Platform Overview
                    </p>  
                    <h6>
                        Lovedripp is a platform that allows users to:
                    </h6>
                    <p>
                        Create personal accounts
                    </p>
                    <p>
                        Showcase upcoming weddings and anniversaries
                    </p>
                    <p>
                        Invite guests to their events
                    </p>
                    <p>
                        Our goal is to celebrate love, milestones, and meaningful connections in a respectful and inclusive environment.<br/>
                        2. User Responsibilities
                    </p>
                    <p>
                        By using Lovedripp, you agree:
                    </p>
                    <p>
                        To provide accurate and complete information during registration.
                    </p>
                    <p>
                        To be solely responsible for the content you post, including text, images, and event information. 
                    </p>
                    <p>
                        Not to post, upload, or share:<br/>
                        Any profanity or obscene language. Explicit nudity or sexually explicit content. Derogatory remarks, hate speech, threats, or harassment targeting individuals or groups based on race, ethnicity, religion, gender, sexual orientation, disability, or any other protected characteristic.
                        Not to impersonate others or misrepresent your affiliation with any person or entity. Not to engage in any activity that interferes with or disrupts the Platform or its users.
                    </p>
                    <p>
                        Any profanity or obscene language. Explicit nudity or sexually explicit content. Derogatory remarks, hate speech, threats, or 
                        harassment targeting individuals or groups based on race, ethnicity, religion, gender, sexual orientation, disability, or any other protected 
                        characteristic.
                    </p>
                    <p>
                        Not to impersonate others or misrepresent your affiliation with any person or entity. Not to engage in any activity that interferes with or disrupts the Platform or its users.
                    </p>
                    <p>
                        Violation of any of these rules may result in immediate suspension or permanent termination of your account. <br/>
                        3. Content Rights
                    </p>
                    <p>
                        You retain ownership of the content you submit, but you grant Lovedripp a non-exclusive, royalty-free license to display and distribute that content on our Platform, solely for the purpose of operating and promoting your event.
                    </p>
                    <p>
                        You are responsible for ensuring you have the legal rights to post any content, including photos or videos featuring other people.<br/>
                        4. Termination
                    </p>
                    <p>
                        We reserve the right to suspend or terminate accounts that violate these Terms, without prior notice. This includes, but is not limited to, 
                        posting prohibited content or engaging in abusive behavior.<br/>
                        5. Privacy
                    </p>
                    <p>
                        Our [Privacy Policy] explains how we handle your personal information. By using the Platform, you also agree to the practices described in our 
                        Privacy Policy.<br/>
                        6. Changes to These Terms
                    </p>
                    <p>
                         We may update these Terms at any time. If we make material changes, we will notify you through the Platform or via email. Continued use of the Platform after changes take effect constitutes your acceptance of the new Terms.
                    </p>
                </div>               
            </div>
      </div>
      <MainFooter />
    </div>
  )
}

export default TermsnConditions